import { Checkbox } from "rsuite";

const SCCheckboc = props => {
  return <Checkbox {...props}>{props.children}</Checkbox>;
};

export default SCCheckboc;
